import { createSelector, createSlice } from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";

export function getColModData({ modId, url, ignoreCondition = false }) {
  return async (dispatch, getState) => {
    const { status } = selectColModData(getState(), modId);

    if (!ignoreCondition && status !== "idle") {
      return;
    }

    dispatch(statsCollectiveActions.loadPending({ modId }));

    return api
      .get(url)
      .then((res) =>
        dispatch(
          statsCollectiveActions.loadSucceeded({ modId, data: res.data })
        )
      )
      .catch((err) =>
        dispatch(
          statsCollectiveActions.loadRejected({
            modId,
            data: err.response?.data,
          })
        )
      );
  };
}

const initialState = {
  dataVizType: "dashboard", // L'init se fait dans loadCoreData
};

const statsCollectiveSlice = createSlice({
  name: "statsCollective",
  initialState,
  reducers: {
    loadPending: (state, action) => {
      state[action.payload.modId] = {
        data: null,
        status: "pending",
        error: null,
      };
    },
    loadSucceeded: (state, action) => {
      state[action.payload.modId].status = "fulfilled";
      state[action.payload.modId].data = action.payload.data;
    },
    loadRejected: (state, action) => {
      state[action.payload.modId].status = "rejected";
      state[action.payload.modId].error = action.payload.data;
    },
    setDataVizType: (state, action) => {
      const { id, userPk } = action.payload;
      state.dataVizType = id;
      localStorage.setItem(`user${userPk}_coll_dataviz_type_v2`, id);
    },
    invalidateCache: (state) => {
      return { dataVizType: state.dataVizType };
    },
  },
  extraReducers: (builder) => {
    builder.addCase("auth/logout", () => initialState);
  },
});

export const statsCollectiveActions = statsCollectiveSlice.actions;

export const selectStatsCollective = (state) => state.statsCollective;

export const selectColModData = createSelector(
  [(state) => selectStatsCollective(state), (state, modId) => modId],
  (data, modId) => data[modId] || { data: null, status: "idle", error: null }
);

// memo ok
export const selectLoadedCollModsIds = createSelector(
  [(state) => selectStatsCollective(state)],
  (data) => {
    const numericKeys = Object.keys(data)
      .filter((key) => !isNaN(key) && !isNaN(parseInt(key)))
      .map(Number);

    return numericKeys; // [234, 334]
  }
);

export const selectDataVizType = createSelector(
  [(state) => state.statsCollective.dataVizType],
  (dataVizType) => dataVizType || "dashboard"
);

export default statsCollectiveSlice.reducer;
